import { logClientError } from 'src/util/server-log';
import { Component, DestroyRef, inject, OnInit, signal } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ReactiveFormsModule, FormControl, Validators } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { Router } from "@angular/router";
import { MaskDirective } from "@directives/mask/mask.directive";
import { SharedService } from "@services/shared/shared.service";
import { GrpcAuthService } from "@services/grpc-auth/grpc-auth.service";
import { cellphoneValidator } from "src/util/validators";

@Component({
  selector: "app-phone-required-modal",
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MaskDirective],
  templateUrl: "./phone-required-modal.component.html",
  styleUrl: "./phone-required-modal.component.css",
})
export class PhoneRequiredModalComponent implements OnInit {
  private readonly shared = inject(SharedService);
  private readonly grpcAuth = inject(GrpcAuthService);
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);

  phoneControl = new FormControl("", [Validators.required, cellphoneValidator]);
  loading = signal(false);
  errorMessage = signal("");
  visible = signal(false);

  ngOnInit(): void {
    this.shared.user$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((user) => {
        if (!user) {
          this.visible.set(false);
          return;
        }
        const phone = (user.phone || "").replace(/\D/g, "");
        const needsPhone = phone.length === 0;
        this.visible.set(needsPhone);
        if (needsPhone) {
        }
      });
  }

  async onSubmit(): Promise<void> {
    if (this.phoneControl.invalid || this.loading()) return;

    this.loading.set(true);
    this.errorMessage.set("");

    const rawPhone = (this.phoneControl.value || "").replace(/\D/g, "");

    try {
      const currentUser = this.shared.user;
      const firstName = currentUser?.["given_name"] || currentUser?.["firstName"] || undefined;
      const lastName = currentUser?.["family_name"] || currentUser?.["lastName"] || undefined;
      await this.grpcAuth.changeUserProfile(firstName, lastName, rawPhone);

      // Re-fetch user from server to confirm the phone was saved
      await this.grpcAuth.getAndSetCurrentUser();
      this.shared.updateCookies();
      // Modal will auto-hide via user$ subscription when phone is present
      // Handle any pending redirect using Angular Router (no page reload)
      const pendingUrl = sessionStorage.getItem("pendingRedirectUrl");
      sessionStorage.removeItem("pendingRedirectUrl");

      this.loading.set(false);

      if (pendingUrl && pendingUrl.trim() !== "") {
        if (pendingUrl.startsWith("http")) {
          window.location.href = pendingUrl;
        } else {
          this.router.navigateByUrl(pendingUrl);
        }
      }
    } catch (error: any) {
      logClientError("[PhoneModal] Erro ao salvar telefone:", error);
      this.errorMessage.set(
        error?.message || "Erro ao salvar o telefone. Tente novamente.",
      );
      this.loading.set(false);
    }
  }
}
